"use client";

import type { ReactNode } from "react";
import { trackProductEvent } from "@/lib/analytics";
import { hentSamtykke, STRIPE_SAMTYKKE_REF } from "@/lib/samtykke";

// Checkout-knapp (ekstern Stripe-lenke) med begin_checkout-event,
// for bruk i server-komponenter som ikke selv kan ha onClick.
export function CheckoutLink({
  href,
  className,
  children,
  slug,
  price,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  slug: string;
  price: number;
}) {
  return (
    <a
      href={href}
      className={className}
      onClick={(e) => {
        trackProductEvent("begin_checkout", { content_name: slug, value: price, currency: "NOK" });
        // Kjøpet sendes til Meta (CAPI i Stripe-webhooken) bare når kjøperen har sagt
        // ja til markedsføring. Stripe tar imot client_reference_id som URL-parameter
        // på Payment Links og legger den på checkout-sesjonen webhooken leser.
        if (hentSamtykke()?.marketing && href.startsWith("https://")) {
          const url = new URL(href);
          url.searchParams.set("client_reference_id", STRIPE_SAMTYKKE_REF);
          e.currentTarget.href = url.toString();
        }
      }}
    >
      {children}
    </a>
  );
}
